import type { FaireThemeEntity } from "../../entity_types/theme";

export const non_toxic_family_first_aid: FaireThemeEntity = {
  token: "non-toxic-family-first-aid",
  type: "theme",
  name: "Non-Toxic Family First Aid",
  description: "Safe, plant-based solutions for the whole family -- germ protection to skin relief.",
  teaser: "Plant-based first aid your family-focused customers trust.",
  detail: "Your strong interest in kids' clothing, baby gowns, and non-toxic ingredients makes clean wellness for families a natural brand extension. Anchored by Immunity Spray made from 100% pure therapeutic grade oils.",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_j8agz743k5",
    "p_wffdgdysuk",
    "p_32kc4ma84p",
    "p_6h33ns0q1u",
    "p_pjqttgrnmd",
    "p_qj2fj89sks",
    "p_vhvdx5qjqz",
    "p_mna0e5vjkz",
    "p_zzsydxceff",
    "p_3acv96vu7y",
    "p_e0o76l8h3x",
    "p_1k91llzd5y",
    "p_sd4g2rste3",
    "p_60yjgd5qev",
    "p_s5786364kd",
    "p_nm8cq573vu",
    "p_d7cg8rzxnf",
    "p_mgwqbfxwjc",
    "p_dq7xq8yxvc",
    "p_vebchz6vrq",
    "p_sm4vtkuaq7",
    "p_eunmj5rq9y",
    "p_bdkp66jbxs",
    "p_9hu8nc34k4",
    "p_zdszxza3yd",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
